import { render, staticRenderFns } from "./SelectCreate.vue?vue&type=template&id=23ee2415&"
import script from "./SelectCreate.vue?vue&type=script&lang=js&"
export * from "./SelectCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports